module.exports = __webpack_public_path__ + "static/media/water-pump-mr-card-front.81402581.jpeg";